module.exports = {
    lpool: '0x2b14c1237a3f807Ea7C5C509636d2FD3A6855E84',
    foundation: '0x000310291683d6d6ec198cde36c4cd1383f8bee1',
    presale: '0xb406daad0b8c447e4566666f3c3986a399f75eae',
    partners: '0x402067331075b558a38ccd934234a1c4c0a37bb6',
    dao: '0xce6e7dd39487ab304937cab29b3ebde1c96740da',
    team: '0x277c2b0e003ecb56c3bd7a4cfc86e49b179ba6d9',
    stakingLPOOL: '0xF92de9bA959FCB9c50414caD07598049c1D08Ba1',
    stakingUnizen: '0xb202CCbeBB4C472657f16F30bF277d3BE7F4781a',
    pStakingUnizen: '0x078f188810ad3F2506a4FD76a982F281f4df15F2',
    burn: '0x0000000000000000000000000000000000000000',
    burn2: '0x881d40237659c251811cec9c364ef91dc08d300c',
    bridge: '0xc677cc253893513329F6a01c9667e582C7DEB217',
    bridge2: '0x7E81570E9135baeE930da7E489503b8A3834F621'
};